import l from 'loglevel'
import remote from 'loglevel-plugin-remote'
import { logServerUrl } from '@/config'
import store from '@/store'

remote.apply(l, {
  url: logServerUrl,
  token: store.state.userToken
})

l.t = l.trace
l.d = l.debug
l.i = l.info
l.w = l.warn
l.e = l.error

l.setLevel('TRACE')

export default l
